import React, { useContext } from "react";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Loading from "../core/Loading";
import AlertPermanent from "../core/AlertPermanent";
import AuthContext from "../../context/authentication/authContext";
import TableContext from "../../context/table/tableContext";
import AlertContext from "../../context/alert/alertContext";
import SyncSvg from "../../assets/icon/published_with_changes-black-18dp.svg"//"../../assets/icon/published_with_changes-black-18dp.svg";

const styles = (theme) => ({
  root: {
    display: "flex",
    marginTop: theme.spacing(3),
    height: "100%",
    overflow: "auto",
  },
  table: {
    minWidth: 340,
  },
  tableCell: {
    padding: "16px",
    color: "#12b1ee",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 70,
  },
  documentNumber: {
    cursor: "pointer",
  },
});

const RcofHistoryTable = (props) => {
  const authContext = useContext(AuthContext);
  const { closeSession } = authContext;
  const tableContext = useContext(TableContext);
  const alertContext = useContext(AlertContext);
  const {
    loading,
    changePage,
    currentPage,
    error,
    errorMessage,
    maxPerPage,
    setMaxPerPage,
    postRegenerateSingleRcof,
  } = tableContext;
  const { classes, columns, data, totalPages } = props;


  const handlePagination = (e, page) => {
    e.preventDefault();
    changePage(page);
  };


  const { showAlert } = alertContext;

  const regenerateSingleRcof = async (trackingId) => {

    try {
      const response = await postRegenerateSingleRcof(trackingId);
      //console.log(`resp = ${JSON.stringify(response)}`)
      if (!response.status) {
        if (response.msg === undefined || response.msg === null)
          alert("Ha ocurrido un error regenerando el RCOF");
        else
          alert(response.msg);
      } else {
        alert("RCOF regenerado correctamente");
      }
      /* showAlert("Archivo descargado", "success"); */
    } catch (error) {
      showAlert("Ha ocurrido un error regenerando el RCOF", "error");
      /*   if(!error.status){
        showAlert("Ha ocurrido un error con la descarga", "error");
      } */
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setMaxPerPage(parseInt(e.target.value, 10));
  };

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <AlertPermanent category="error" message={errorMessage} />;
  }

  if (data.length === 0 && !error) {
    return (
      <AlertPermanent
        category="info"
        message="No se han encontrado RCOF Históricos..."
      />
    );
  }

  if (error) {
    return <AlertPermanent category="error" message={errorMessage} />;
  }

  return (
    <>
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  className={classes.tableCell}
                  align="center"
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((n, index) => {
              return (
                <TableRow key={index}>
                  <TableCell
                    component="th"
                    scope="row"
                    className={classes.TableCell}
                    align="center"
                  >
                    {moment(n.date).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell align="center">
                    {n.trackingId}
                  </TableCell>
                  <TableCell align="center">
                    {n.transactionQuantity === null ? "N/A" : n.transactionQuantity}
                  </TableCell>
                  <TableCell align="center">
                    {n.affectedTotalAmount === null ? "N/A" : "$" + Number(n.affectedTotalAmount).toLocaleString("da-DK")}
                  </TableCell>
                  <TableCell align="center">
                    {n.notAffectedTotalAmount === null ? "N/A" : "$" + Number(n.notAffectedTotalAmount).toLocaleString("da-DK")}
                  </TableCell>
                  <TableCell align="center">
                    {n.totalAmount === null ? "N/A" : "$" + Number(n.totalAmount).toLocaleString("da-DK")}
                  </TableCell>
                  <TableCell align="center">
                    <img src={SyncSvg} alt="Regenerar RCOF" title="Regenerar RCOF" className={classes.documentNumber} onClick={() => { regenerateSingleRcof(n.trackingDetailId) }}></img>
                    {/* {n.showRegenerateButton ? <img src={SyncSvg} alt="Regenerar RCOF" title="Regenerar RCOF" className={classes.documentNumber} onClick={() => { regenerateSingleRcof(n.trackingDetailId) }}></img> : ""} */}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Registros</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={maxPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={500}>500</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          page={currentPage}
          count={totalPages}
          onChange={handlePagination}
          style={{ marginTop: "10px", justifyContent: "center" }}
        />
      </div>
    </>
  );
};



export default withStyles(styles)(RcofHistoryTable);
